const comisionesModulo = {
    agGrid: {
        paginacion: 15,
        id: 'myGrid',
        class: 'ag-theme-alpine',
        style: {
            width: '100%',
            height: '700px'
        }
    },
    titulos: {
        consultaDeProcesos: {
            titulo: 'Consulta de Procesos',
            modulo: 'RPlus',
            tituloCardListar: 'Listar Consultas de Procesos',
        },
        ejecucionDeProcesos: {
            titulo: 'Ejecución de Procesos',
            modulo: 'RPlus',
            tituloCardListar: 'Listar Ejecución de Procesos',
        },
        parametrizarValorFlete: {
            titulo: 'Valor de Flete',
            modulo: 'Balanza',
            tituloCardListar: 'Listar Valor de Flete',
            tituloAgregar: 'Agregar Valor de Flete',
            tituloActualizar: 'Actualizar Valor de Flete'
        },

    },
    agGridModal: {
        paginacion: 10,
        id: 'myGrid',
        class: 'ag-theme-material mt-3',
        style: {
            width: '100%',
            height: '450px'
        }
    },
    url: {
        comisiones: {
            obtenerTodo: 'vendedor-tipo',
            obtenerPorId: 'vendedor-tipo/',
            obtenerPorEstado: 'vendedor-tipo/estado?idEstado=',
            crear: 'vendedor-tipo',
            actualizar: 'vendedor-tipo',
            eliminar: 'vendedor-tipo/',
            maestros: {
                getUnidadesNegocioSAP: 'unidad-negocio',
            },
        },
        calendario: {
            obtenerTodo: 'calendario',
            crear: 'calendario',
            actualizar: 'calendario',
            eliminar: 'calendario',
            duplicar: 'calendario/duplicar',
            crearPeriodo: 'calendario-periodo',
            obtenerPeriodo: 'calendario-periodo/',
            eliminarPeriodo: 'calendario-periodo',
        },
        asignacionCalendario: {
            obtenerTodo: 'calendario-vendedor-tipo',
            crear: 'calendario-vendedor-tipo',
            actualizar: 'calendario-vendedor-tipo',
            eliminar: 'calendario-vendedor-tipo',
        },
        altaDeVendedores: {
            obtenerTodo: 'vendedores',
            obtenerPorId: 'vendedores/',
            obtenerPorTipo: 'vendedores/tipo-vendedor?idTipoVendedor=',
            obtenerPorEstado: 'vendedores/estado?idEstado=',
            crear: 'vendedores',
            actualizar: 'vendedores',
            eliminar: 'vendedores/',
            maestros: {
                getVendedorPorCedula: 'vendedores/nomina/',
            },
        },
        variables: {
            obtenerTodo: 'variables',
            obtenerPorId: 'variables/',
            obtenerPorEstado: 'variables/estado?idEstado=',
            crear: 'variables',
            actualizar: 'variables',
            eliminar: 'variables/',
            tiposDeRecursos: 'variables/tipo-recurso',
            tiposDeVariables: 'variables/tipo-variables',
            tiposDeMedidas: 'variables/tipo-medida?recurso=',
        },
        cumplimientoVsGanancia: {
            obtenerPorTipoDeVendedor: 'cumplimiento-ganancia/tipo-vendedor?tipoVendedor=',
            obtenerTodo: 'cumplimiento-ganancia',
            obtenerPorId: 'cumplimiento-ganancia/',
            crear: 'cumplimiento-ganancia',
            actualizar: 'cumplimiento-ganancia',
            eliminar: 'cumplimiento-ganancia/',
            recepcionCsv: 'cumplimiento-ganancia/upload/csv/save',
            recepcionCsvSave: 'cumplimiento-ganancia/recepcion/csv/save',
            maestros: {
                getVendedorPorCedula: 'cumplimiento-ganancia/nomina/',
            },
        },
        asignaciones: {
            obtenerTodo: 'asignacion-fija',
            obtenerPorId: 'asignacion-fija/',
            obtenerPorIdDetalle: 'asignacion-fija-detalle/',
            filtrarPorVendedor: 'asignacion-fija/filtrar?idVendedorTipo=',
            crear: 'asignacion-fija',
            actualizar: 'asignacion-fija',
            eliminar: 'asignacion-fija/',
            recepcionCsv: 'asignacion-fija/upload/csv/save',
            recepcionCsvSave: 'asignacion-fija/recepcion/csv/save',
            getVendedor: '/vendedor/id/',
            crearDetalle: 'asignacion-fija-detalle/lista',
            obtenerSubDistribuciones: 'asignacion-subcategoria/',
            crearSubCategorias: 'asignacion-subcategoria',
            crearSubDistribuciones: 'asignacion-subcategoria/lista',
            obtenerPorTiposDeVendedoresGrid: 'asignacion-fija/filtrar?idVendedorTipo=',
            maestros: {
                getVendedor: '/vendedor/id/',
                getMacroCategorias: 'macrocategoria',
                getLineas: 'linea/macrocategoria/',
                getCategorias: 'categoria/linea/',
                getSubCategorias: 'subcategoria/categoria/',
            },
        },
        asignacionDistribucion: {
            obtenerTodo: 'asignacion-compensacion',
            obtenerPorTipoDeVendedor: 'asignacion-compensacion/filtrar?idVendedorTipo=',
            crear: 'asignacion-compensacion',
            actualizar: 'asignacion-compensacion',
            eliminar: 'asignacion-compensacion/',
            recepcionCsv: 'asignacion-compensacion/upload/csv/save',
            recepcionCsvSave: 'asignacion-compensacion/recepcion/csv/save',
        },
        asignacionDistribucionIncentivos: {
            obtenerTodo: 'asignacion-incentivo',
            obtenerPorId: 'asignacion-incentivo/',
            obtenerPorTipoDeVendedor: 'asignacion-incentivo/filtrar?idVendedorTipo=',
            crear: 'asignacion-incentivo',
            actualizar: 'asignacion-incentivo',
            eliminar: 'asignacion-incentivo/',
            recepcionCsv: 'asignacion-incentivo/upload/csv/save',
            recepcionCsvSave: 'asignacion-incentivo/recepcion/csv/save',
        },
        cargaInicialPromediosComision: {
            obtenerTodo: 'promedio-comision/',
            recepcionCsv: 'promedio-comision/upload/csv/save',
            recepcionCsvSave: 'promedio-comision/recepcion/csv/save',
        },
        cargaMetaIncentivoSellOut: {
            obtenerTodo: 'metas-incentivo/',
            recepcionCsv: 'metas-incentivo/upload/csv/save',
            recepcionCsvSave: 'metas-incentivo/recepcion/csv/save',
        },
        procesarComisiones: {
            obtenerTodo: 'liquidacion/',
            obtenerPorId: 'liquidacion/',
            procesarLiquidacion: 'liquidacion/procesar/',
            guardarLiquidacion: 'liquidacion/guardar/',
            cerrarLiquidacion: 'liquidacion/cerrar/',
            eliminarLiquidacion: 'liquidacion/eliminar/',
            unidadesDeNegocio: 'unidad-negocio',
            filtroEstado: 'liquidacion/estado?tipoLiquidacion=0&idEstado=',
            filtroDetalle: 'liquidacion/filtrar-estado/?estado=',
            obtenerTiposDeVendedoresPorUnidadesDeNegocios: '/vendedor-tipo/unidad-negocio',
        },
        procesarComisionesExcolaboradores: {
            obtenerTodo: 'liquidacion/',
            obtenerPorId: 'liquidacion/',
            procesarLiquidacion: 'liquidacion/procesar-excolaborador/',
            guardarLiquidacion: 'liquidacion/guardar/',
            cerrarLiquidacion: 'liquidacion/cerrar/',
            eliminarLiquidacion: 'liquidacion/eliminar/',
            unidadesDeNegocio: 'unidad-negocio',
            filtroEstado: 'liquidacion/estado?tipoLiquidacion=1&idEstado=',
            filtroDetalle: 'liquidacion/filtrar-estado/?estado=',
            obtenerTiposDeVendedoresPorUnidadesDeNegocios: '/vendedor-tipo/unidad-negocio',
        },
        procesarComisionesFondoVehicular: {
            obtenerTodo: 'liquidacion/',
            obtenerPorId: 'liquidacion/',
            procesarLiquidacion: 'liquidacion/procesar-vehicular/',
            guardarLiquidacion: 'liquidacion/guardar/',
            cerrarLiquidacion: 'liquidacion/cerrar/',
            eliminarLiquidacion: 'liquidacion/eliminar/',
            unidadesDeNegocio: 'unidad-negocio',
            filtroEstado: 'liquidacion/estado?tipoLiquidacion=2&idEstado=',
            filtroDetalle: 'liquidacion/filtrar-estado/?estado=',
            obtenerTiposDeVendedoresPorUnidadesDeNegocios: '/vendedor-tipo/unidad-negocio',
        },
        cargaCarteras: {
            getTodo: 'cartera-cargas/',
            recepcionCsv: 'cartera-cargas/upload/csv/save?',
            recepcionCsvSave: 'cartera-cargas/recepcion/csv/save',
        },
        reporteAvanceDeComisionesIndividuales: {
            obtenerTodo: 'liquidacion/avance?',
        },
        reporteLiquidacionIndividual: {
            obtenerTodo: 'liquidacion/filtrar',
            reporteTotal: 'liquidacion/reporte/excel?',
            reporteIndividual: 'liquidacion/reporte/excel/individual?',
        },
        habilitarPeriodoDeComisiones: {
            obtenerTodo: 'liquidacion',
            habilitarPeriodo: 'liquidacion-revision',
        },
        vendedoresRelacionados: {
            crear: 'vendedor-relacionado',
            editar: 'vendedor-relacionado',
            eliminar: 'vendedor-relacionado/',
            filtrar: 'vendedor-relacionado/filtrar?idVendedorTipo=',
            getVendedor: '/vendedor/id/',
        },
        maestros: {
            getVendedor: '/vendedor/id/',
            getMacroCategorias: 'macrocategoria'
        },
    },
    button: {
        buttonsCss: {
            primary: 'btn btn-primary btn-block',
            secondary: 'btn btn-secondary btn-block',
            success: 'btn btn-success btn-block',
            danger: 'btn btn-danger btn-block',
            warning: 'btn btn-warning btn-block',
            info: 'btn btn-info btn-block',
            light: 'btn btn-light btn-block',
            dark: 'btn btn-dark btn-block',
            primaryOutline: 'btn btn-outline-primary',
            secondaryOutline: 'btn btn-outline-secondary',
            successOutline: 'btn btn-outline-success',
            dangerOutline: 'btn btn-outline-danger',
            warningOutline: 'btn btn-outline-warning',
            infoOutline: 'btn btn-outline-info',
            lightOutline: 'btn btn-outline-light',
            darkOutline: 'btn btn-outline-dark',
            primarylg: 'btn btn-primary btn-lg btn-block',
            successLg: 'btn btn-success btn-lg btn-block',
            dangerLg: 'btn btn-danger btn-lg btn-block',
            warningLg: 'btn btn-warning btn-lg btn-block',
            warningLgFile: 'btn btn-warning btn-lg btn-block btn-file',
        },
        buttonsNombre: {
            editar: 'Editar',
            ver: 'Ver',
            eliminar: 'Eliminar',
            agregar: 'Agregar ',
            guardar: 'Guardar',
            actualizar: 'Actualizar',
            mostrar: 'Mostrar seleccion',
            regresar: 'Regresar',
            continuar: 'Continuar',
            seleccionar: 'Seleccionar',
            procesar: 'Procesar',
            buscar: 'Buscar',
            sustento: 'Sustento',
            validar: 'Validar',
            descargar: 'Descargar',
            descargarRecibo: 'Descargar Recibo Cobros',
            descargarEstado: 'Descargar Estados Docs',
            detalle: 'Ver Ordenes',
            agregarProducto: 'Añadir Productos',
            anadirProducto: 'Añadir',
            limpiar: 'Eliminar todos los productos',
            anular: 'Anular',
            aprobar: 'Aprobar',
            cambiarPresupuesto: 'Cambiar Vendedor Presupuesto',
            imprimir: 'Imprimir',
        }
    },
    mensajes: {
        errorServicio: 'error..!!',
        desabilitada: 'Opción desabilitada',
        eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
        guardar: '¿Esta seguro que desea guardar el siguiente elemento?',
        actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
        datoGuardado: 'Se guardo corectamente..!!',
        guardarParada: 'Esta seguro que desea registrar este evento..??',
        procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
        validar: '¿Esta seguro que desea validar el siguiente elemento?',
        anticipo: 'Se tomara este valor como anticipo.',
        camposObligatorio: 'Los campos tipo transaccion y número documento deben estar llenos caso contrario se tomara como anticipo.',
        anular: 'Confirma que desea eliminar el registro seleccionado.',
        cambiarPresupuesto: '¿Está seguro que desea cambiar el código vendedor de los siguientes registros?'
    },
    colors: {
        verde: 'green',
        azul: 'blue',
        rojo: 'red'
    },
    imagenes: {
        regalo: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>',
        item: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>'
    },
    div: {
        resposiveFull: 'col-12 col-sm-6 col-md-6 col-lg-4 ',//verificar el tipo de pantalla
    }
}


export { comisionesModulo }